import * as React from 'react'

function SvgCheckIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path d="M26.816 11.436c.11.056.218.117.322.183l-1.507 1.507a4.2 4.2 0 0 0-.567-.078c-.566-.046-1.31-.048-2.464-.048h-5.2c-1.153 0-1.898.002-2.464.048-.544.044-.745.12-.844.17a2 2 0 0 0-.874.874c-.05.099-.126.3-.17.844-.046.566-.048 1.31-.048 2.464v5.2c0 1.153.002 1.898.048 2.464.044.544.12.745.17.844a2 2 0 0 0 .874.874c.099.05.3.126.844.17.566.046 1.31.048 2.464.048h5.2c1.153 0 1.898-.002 2.464-.048.544-.044.745-.12.844-.17a2 2 0 0 0 .874-.874c.05-.099.126-.3.17-.844.046-.566.048-1.31.048-2.464v-2.357l2-2V22.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C25.96 29 24.84 29 22.6 29h-5.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C11 25.96 11 24.84 11 22.6v-5.2c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C14.04 11 15.16 11 17.4 11h5.2c2.24 0 3.36 0 4.216.436Z" />
      <path d="M30.354 14.06a.5.5 0 0 0 0-.706l-.707-.707a.5.5 0 0 0-.708 0l-8.585 8.585a.5.5 0 0 1-.707 0l-3.586-3.585a.5.5 0 0 0-.707 0l-.707.707a.5.5 0 0 0 0 .707l5 5a.5.5 0 0 0 .707 0l10-10Z" />
    </svg>
  )
}

export default SvgCheckIcon
